import React, { useEffect } from 'react';

import { useRouter } from 'expo-router';
import { MenuSkeletonLoader } from 'features/menu/components/menu-tile-grid/menu-tile-grid-loading';

import { navigateToUnavailableFullMenu } from 'experiments/deeplinks-flow-feature/treatment/features/menu/utils/navigate-to-unavailable-full-menu';

type UnavailableSectionRecoveryProps = {
  sectionId: string;
  /** Preserved for call-site compatibility; Full Menu recovery does not need them. */
  targetItemIds?: string[];
  /** Unavailable product to pin when its parent section is missing at this store. */
  unavailableItemId?: string;
};

/**
 * Treatment: store-scoped section is missing/empty — send the guest to Full Menu
 * with unavailable recovery chrome (product card and/or section pin above other
 * available options/categories).
 */
export function UnavailableSectionRecovery({
  sectionId,
  unavailableItemId,
}: UnavailableSectionRecoveryProps) {
  const router = useRouter();

  useEffect(() => {
    if (!sectionId && !unavailableItemId) {
      return;
    }
    navigateToUnavailableFullMenu(router, {
      ...(sectionId ? { sectionId } : {}),
      ...(unavailableItemId ? { itemId: unavailableItemId } : {}),
    });
  }, [router, sectionId, unavailableItemId]);

  return <MenuSkeletonLoader />;
}
